<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @change-selected="changeSelectedTable"
                            ref="gofixTable">
                            <template slot="gofix_table:after-control-left">
                                <gofix-button class="ml-2" label="Proceed" outline @click="proceedApproval"></gofix-button>
                            </template>
                            <template slot="gofix_table:total" slot-scope="data">
                                {{data.item.total  | formatMoney}}
                            </template>
                            <template slot="gofix_table:order_issue_date" slot-scope="data">
                                {{data.item.order_issue_date  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:completed_date" slot-scope="data">
                                {{data.item.completed_date  | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
        <ApprovalMultiple 
            title="Approval For Multiple Orders" 
            :orders="proceed.ids" v-model="proceed.open"
            @approval-success="$refs.gofixTable.reloadTableKeepFilter()" />
    </div>
</template>
<script>
    const ApprovalMultiple = () => import('@/views/dashboard-approval/approval-multiple')
    import { filters } from '@/_filterVar.js'
    export default {
        name: 'Orders',
        components: {
            ApprovalMultiple
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['order_approval']));
            return {
                tableConfig:{
                    dataSelect: {
                        order_status: {
                            value: [
                                {value: 'Issued', text: 'Issued'},
                                {value: 'COD Raised', text: 'COD Raised'},
                                {value: 'Under Approval', text: 'Under Approval'},
                                {value: 'Pending Revision', text: 'Pending Revision'},
                                {value: 'Approved', text: 'Approved'},
                                {value: 'Dispatched', text: 'Dispatched'},
                                {value: 'Acknowledged', text: 'Acknowledged'},
                                {value: 'Rejected', text: 'Rejected'},
                                {value: 'On-Site', text: 'On-Site'},
                                {value: 'Partially Completed', text: 'Partially Completed'},
                                {value: 'Completed', text: 'Completed'},
                                {value: 'Invoiced', text: 'Invoiced'},
                                {value: 'Closed', text: 'Closed'},
                                {value: 'Cancelled', text: 'Cancelled'}
                            ],
                            value_field: 'value',
                            text_field: 'text'
                        }
                    },
                    name: 'fm---facilities-management-work-orders',
                    controls:{
                        create: false,
                        delete: false,
                        tableImport: false,
                        tableExport: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    isCMS: true,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "desc",
                },
                tableItems:[],
                proceed: {
                    open: false,
                    ids:  []
                }
            }
        },
        methods: {
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.type_check = 'order_fm';
                await this.$store.dispatch("AwaitingApprovalController/getAwaitingApproval", tableRequest)
                    .then(response => {                        
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load orders", "danger");
                        reject();
                    });
            },
            clickToRowItem(item){
                this.$router.push(`/approvals/orders/${item.id}`);
            },
            changeSelectedTable(ids) {
                this.proceed.ids = ids;
            },
            proceedApproval() {
                if(!this.proceed.ids.length)
                    return this.$alertNotification('Please select at least one item before proceed', 'danger');
                this.proceed.open = true;
            }
        }
    }
</script>
